/** #@condition: betradar **/
/** Only if we need built in betradar support **/
import MojitoServices from 'mojito/services';

import {loadStyle} from '#core/utils/utils.js';
import {absoluteUrlToInternalResource} from '#core/utils/url-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import SCHEMA from './betradar.schema.yaml';

const {notificationEventResolverService} = MojitoServices.SportsContent.NotificationEvent;

class BetradarFeature extends AbstractVisualFeature {
    constructor(parent) {
        super(parent);

        this.styleLoaded = false;
    }

    get name() {
        return 'Betradar';
    }

    get configSchema() {
        return SCHEMA;
    }

    getSerializableVisualConfig() {
        return {
            BetradarMatchTracker: {
                widgetLoaderUrl: this.config.widgetURL,
                widgetLoaderConfig: this.config.widgetLoaderConfig,
                widgetConfig: this.config.widgetConfig,
                languagesMapping: this.config.languagesMapping,
            },
            InplayEventController: {
                notificationsIdSearchParam: {
                    name: 'provider',
                    value: 'betradar',
                },
            },
        };
    }

    updateMojitoConfig(mojitoConfig) {
        mojitoConfig.services.notificationEventResolverService = notificationEventResolverService;
        super.updateMojitoConfig(mojitoConfig);
    }

    beforeMount(containerEl) {
        if (this.config.widgetLoaderConfig?.theme === false && !this.styleLoaded) {
            loadStyle(absoluteUrlToInternalResource('betradar-theme.css'));
            this.styleLoaded = true;
        }

        return super.beforeMount(containerEl);
    }
}

export const Betradar = new BetradarFeature(allVisuals);
